import angular from 'angular';
import frame from './frame';

export default angular
  .module('components.frame', [])
  .component('frameComponent', frame).name;
